export default __webpack_public_path__ + "static/sol-healthcare-section-2-img-ccdfa839579b2f6413b682a2836e6de1.png";